<template>
  <section class="mt-10">
    <div class="w-full">
      <div class="mb-10 flex justify-between">
        <div class="w-full">
          <h1
            v-if="user"
            class="text-4xl text-black"
          >
            <span class="font-light">Hello</span>, <span class="font-bold">{{ user.fullName }}!</span>
          </h1>
          <span class="font-light mt-2">Welcome to the Nevnet admin dashboard.</span>
          <div class="h-fit w-full mt-3">
            <div class="border-b border-gray-200 lr-4">
              <div class="flex justify-between pb-3 border-b border-gray-200 dark:border-gray-700">
                <dl>
                  <dt class="flex items-center pb-1 text-base font-normal text-gray-500 dark:text-gray-400">
                    <span>Total revenue</span>
                  </dt>
                  <dd class="text-3xl font-bold leading-none text-gray-900 dark:text-white">
                    £0.00
                  </dd>
                </dl>
              </div>
              <div class="grid grid-cols-2 py-3">
                <dl>
                  <dt class="pb-1 text-base font-normal text-black dark:text-gray-400">
                    Revenue (This Month)
                  </dt>
                  <dd class="text-xl font-bold leading-none text-black dark:text-gray-500">
                    £0.00
                  </dd>
                </dl>
                <dl>
                  <dt class="pb-1 text-base font-normal text-black dark:text-gray-400">
                    Refunds (This Month)
                  </dt>
                  <dd class="text-xl font-bold leading-none text-black dark:text-gray-500">
                    £0.00
                  </dd>
                </dl>
              </div>
            </div>
            <div class="flex animate-pulse mt-8">
              <div class="flex-shrink-0">
                <span class="size-12 block bg-gray-200 rounded-full dark:bg-gray-700" />
              </div>
              <div class="ms-4 mt-2 w-full">
                <h3
                  class="h-4 bg-gray-200 rounded-full dark:bg-gray-700"
                  style="width: 40%;"
                />
                <ul class="mt-5 space-y-3">
                  <li class="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700" />
                  <li class="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700" />
                  <li class="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700" />
                  <li class="w-full h-4 bg-gray-200 rounded-full dark:bg-gray-700" />
                </ul>
              </div>
            </div>
          </div>
        </div>
        <img
          alt="Community support"
          class="h-96"
          src="../../assets/images/admin-dashboard-right.svg"
        >
      </div>
      <div class="grid md:grid-cols-4 border border-gray-200 shadow-sm rounded-xl overflow-hidden dark:border-gray-700">
        <a
          class="block p-4 md:p-5 relative bg-white hover:bg-gray-50 before:absolute before:top-0 before:start-0 before:w-full before:h-px md:before:w-px md:before:h-full before:bg-gray-200 before:first:bg-transparent dark:bg-slate-900 dark:hover:bg-slate-800 dark:before:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
          href="#"
        >
          <div class="flex md:grid lg:flex gap-y-3 gap-x-5">
            <svg
              class="flex-shrink-0 size-5 text-gray-400 dark:text-gray-600"
              fill="none"
              height="24"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle
                cx="9"
                cy="7"
                r="4"
              />
              <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
            <div class="grow">
              <p class="text-xs uppercase tracking-wide font-medium text-gray-800 dark:text-gray-200">
                Total Members
              </p>
              <h3 class="mt-1 text-xl sm:text-2xl font-semibold text-black dark:text-primary"> 00,000 </h3>
              <div class="mt-1 flex justify-between items-center">
                <p class="text-sm text-gray-500"><span
                  class="font-semibold text-gray-800 dark:text-gray-200"
                >00,000</span> active
                </p> <span
                  class="ms-1 inline-flex items-center gap-1.5 py-1 px-2 rounded-md text-xs font-medium bg-gray-200 text-gray-800 dark:bg-gray-800 dark:text-gray-200"
                > <svg
                  class="inline-block size-3 self-center"
                  fill="currentColor"
                  height="16"
                  viewBox="0 0 16 16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                > <path
                  d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                /> </svg> <span
                  class="inline-block"
                > 00.0% </span> </span>
              </div>
            </div>
          </div>
        </a>
        <a
          class="block p-4 md:p-5 relative bg-white hover:bg-gray-50 before:absolute before:top-0 before:start-0 before:w-full before:h-px md:before:w-px md:before:h-full before:bg-gray-200 before:first:bg-transparent dark:bg-slate-900 dark:hover:bg-slate-800 dark:before:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
          href="#"
        >
          <div class="flex md:grid lg:flex gap-y-3 gap-x-5">
            <svg
              class="flex-shrink-0 size-5 text-gray-400 dark:text-gray-600"
              fill="none"
              height="24"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5 22h14" />
              <path d="M5 2h14" />
              <path d="M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22" />
              <path d="M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2" />
            </svg>
            <div class="grow">
              <p class="text-xs uppercase tracking-wide font-medium text-gray-800 dark:text-gray-200">
                Upcoming Events
              </p>
              <h3 class="mt-1 text-xl sm:text-2xl font-semibold text-black dark:text-primary"> 00 </h3>
              <div class="mt-1 flex justify-between items-center">
                <p class="text-sm text-gray-500"><span
                  class="font-semibold text-gray-800 dark:text-gray-200"
                >00</span> this month
                </p> <span
                  class="ms-1 inline-flex items-center gap-1.5 py-1 px-2 rounded-md text-xs font-medium bg-gray-200 text-gray-800 dark:bg-gray-800 dark:text-gray-200"
                > <svg
                  class="inline-block size-3 self-center"
                  fill="currentColor"
                  height="16"
                  viewBox="0 0 16 16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                > <path
                  d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                /> </svg> <span
                  class="inline-block"
                > 00.0% </span> </span>
              </div>
            </div>
          </div>
        </a>
        <a
          class="block p-4 md:p-5 relative bg-white hover:bg-gray-50 before:absolute before:top-0 before:start-0 before:w-full before:h-px md:before:w-px md:before:h-full before:bg-gray-200 before:first:bg-transparent dark:bg-slate-900 dark:hover:bg-slate-800 dark:before:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
          href="#"
        >
          <div class="flex md:grid lg:flex gap-y-3 gap-x-5">
            <svg
              class="flex-shrink-0 size-5 text-gray-400 dark:text-gray-600"
              fill="none"
              height="24"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6" />
              <path d="m12 12 4 10 1.7-4.3L22 16Z" />
            </svg>
            <div class="grow">
              <p class="text-xs uppercase tracking-wide font-medium text-gray-800 dark:text-gray-200">
                Accelerator Applicants
              </p>
              <h3 class="mt-1 text-xl sm:text-2xl font-semibold text-black dark:text-primary"> 00 </h3>
              <div class="mt-1 flex justify-between items-center">
                <p class="text-sm text-gray-500"><span
                  class="font-semibold text-gray-800 dark:text-gray-200"
                >00</span> this month
                </p> <span
                  class="ms-1 inline-flex items-center gap-1.5 py-1 px-2 rounded-md text-xs font-medium bg-gray-200 text-gray-800 dark:bg-gray-800 dark:text-gray-200"
                > <svg
                  class="inline-block size-3 self-center"
                  fill="currentColor"
                  height="16"
                  viewBox="0 0 16 16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                > <path
                  d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                /> </svg> <span
                  class="inline-block"
                > 00.0% </span> </span>
              </div>
            </div>
          </div>
        </a>
        <a
          class="block p-4 md:p-5 relative bg-white hover:bg-gray-50 before:absolute before:top-0 before:start-0 before:w-full before:h-px md:before:w-px md:before:h-full before:bg-gray-200 before:first:bg-transparent dark:bg-slate-900 dark:hover:bg-slate-800 dark:before:bg-gray-700 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600"
          href="#"
        >
          <div class="flex md:grid lg:flex gap-y-3 gap-x-5">
            <svg
              class="flex-shrink-0 size-5 text-gray-400 dark:text-gray-600"
              fill="none"
              height="24"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5 12s2.545-5 7-5c4.454 0 7 5 7 5s-2.546 5-7 5c-4.455 0-7-5-7-5z" />
              <path d="M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
              <path d="M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2" />
              <path d="M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2" />
            </svg>
            <div class="grow">
              <p class="text-xs uppercase tracking-wide font-medium text-gray-800 dark:text-gray-200">
                Investor Network Requests
              </p>
              <h3 class="mt-1 text-xl sm:text-2xl font-semibold text-black dark:text-primary"> 00 </h3>
              <div class="mt-1 flex justify-between items-center">
                <p class="text-sm text-gray-500"><span
                  class="font-semibold text-gray-800 dark:text-gray-200"
                >00</span> this month
                </p> <span
                  class="ms-1 inline-flex items-center gap-1.5 py-1 px-2 rounded-md text-xs font-medium bg-gray-200 text-gray-800 dark:bg-gray-800 dark:text-gray-200"
                > <svg
                  class="inline-block size-3 self-center"
                  fill="currentColor"
                  height="16"
                  viewBox="0 0 16 16"
                  width="16"
                  xmlns="http://www.w3.org/2000/svg"
                > <path
                  d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                /> </svg> <span
                  class="inline-block"
                > 00.0% </span> </span>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import {userKey} from '@/composables/useUser';
import {inject, watchEffect} from "vue";
import {useHead} from "@vueuse/head";

export default {
  name: "AdministratorHome",
  setup() {
    const {user} = inject(userKey)!;

    watchEffect(() => {
      useHead({
        title: 'Admin Dashboard',
      });
    });

    return {user};
  }
}
</script>
